export const GROUP_CODE_EDITOR_LABELS = {
    sectionTitle: "현재코드",
    deleteTitle: "선택한 코드를 삭제하시겠습니까?",
    deleteDescription: "하위 코드가 있으면 삭제할 수 없습니다.",
};

export const GROUP_CODE_CHILD_LABELS = {
    title: "하위 코드",
    description: "하위 코드와 계층을 설정합니다.",
    rootPlaceholder: "하위 코드명",
    addRootLabel: "+ 하위 코드 추가",
    addChildLabel: "+ 하위 코드",
    childPlaceholder: "하위 코드명",
    deleteTitle: "선택한 하위 코드를 삭제하시겠습니까?",
    deleteDescription: "하위 코드가 있으면 삭제할 수 없습니다.",
    emptyMessage: "등록된 하위 코드가 없습니다. 위에서 추가하세요.",
};
